export default __webpack_public_path__ + "0140c89f1d31413f6934c545e5c39009.png";